import { useState, useContext } from 'react';
import { AuthContext } from './AuthContext';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { API_BASE } from '../../services/apiService';
import { DatabaseContext } from "../DatabaseContext";
import { Row, Col } from 'react-bootstrap';

const Login = () => {
  const { login } = useContext(AuthContext);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { updateUserList } = useContext(DatabaseContext);

  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_BASE}/login`, { username, password });
      login(response.data.token); // Save token and decode user info
      navigate("/");
      updateUserList();
    } catch (err) {
      setError('Invalid credentials');
    }
  };

  return <div style={{ width: "100%", justifyContent: "center", alignItems: "center", display: "flex" }}>
    <div style={{ width: "1200px" }}>
      <form onSubmit={handleSubmit}>
        <h4>Login</h4>
        <Row>
          <Col sm={1}>Username</Col>
          <Col sm={4}>
            <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Username" required autoFocus={true} />
          </Col>
          <Col sm={1}></Col >
        </Row>
        <Row>
          <Col sm={1}>Password</Col>
          <Col sm={4}>
            <input type={showPass ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" required />
          </Col>
          <Col sm={1}><p onClick={() => setShowPass(!showPass)} style={{ color: "gray", textDecoration: "underline" }}>{showPass ? "Hide" : "Show"}</p></Col >
        </Row>
        <Row>
          <Col><button type="submit">Login</button></Col>
          <Col>
            {error && <p>{error}</p>}
          </Col>
        </Row>
      </form>
      <br />
      <br />
      <br />
      or <Link to="/signup">Sign up</Link>
    </div >
  </div>
};

export default Login;
